import { Form } from "@form/Form";
import FormInput from "@form/FormInput";
import { useApi } from "../../../../hooks/useApi";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    clubSlug: string;
    callback?: () => void;
}

export const AddRelativeForm: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ clubSlug, callback }) => {
    const { t } = useTranslation('general');
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = (data: { email: string }) => {
        setIsLoading(true);
        return api({
            url: `club/${clubSlug}/relatives`,
            method: "POST",
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: callback,
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormInput name="email" label={t('permissions.addRelativeForm.emailLabel')} type="email" />
            <FormInput.Submit isLoading={isLoading} />
        </Form>
    );
};
